import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/es5/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#FFAC1C",
                secondary: "#55a6cc",
                accent: "#9c27b0",
                error: "#f44336",
                warning: "#ff7707",
                info: "#00B8D4",
                success: "#4caf50",
                font: "#ffffff",
                entry: "#e3e3e3",
                editItem: "#b28bd0",
            },
        },
    },
    lang: {
        locales: {de},
        current: 'de',
    },
    icons: {
        iconfont: 'fa'
    },
});
